<template>
  <ContentWrap>
    <!-- 搜索工作栏 -->
    <el-form
      ref="queryFormRef"
      :inline="true"
      :model="queryParams"
      class="-mb-15px"
      label-width="80px"
    >
      <el-form-item label="关键字" prop="keyword">
        <el-input
          v-model="queryParams.keyword"
          class="!w-240px"
          clearable
          placeholder="平台名称 / 网址 / 账号密码 / 费用说明"
          @keyup.enter="handleQuery"
        />
      </el-form-item>
      <el-form-item label="类型" prop="type">
        <el-select v-model="queryParams.type" class="!w-160px" clearable placeholder="请选择类型">
          <el-option
            v-for="dict in getIntDictOptions(DICT_TYPE.CRM_BID_PLATFORM_TYPE)"
            :key="dict.value"
            :label="dict.label"
            :value="dict.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="收费标准" prop="feeStandard">
        <el-select
          v-model="queryParams.feeStandard"
          class="!w-160px"
          clearable
          placeholder="请选择收费标准"
        >
          <el-option
            v-for="dict in getIntDictOptions(DICT_TYPE.CRM_BID_PLATFORM_FEE_STANDARD)"
            :key="dict.value"
            :label="dict.label"
            :value="dict.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="合作状态" prop="cooperationStatus">
        <el-select
          v-model="queryParams.cooperationStatus"
          class="!w-160px"
          clearable
          placeholder="请选择合作状态"
        >
          <el-option
            v-for="dict in getIntDictOptions(DICT_TYPE.CRM_BID_PLATFORM_COOPERATION_STATUS)"
            :key="dict.value"
            :label="dict.label"
            :value="dict.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button @click="handleQuery">
          <Icon class="mr-5px" icon="ep:search" />
          搜索
        </el-button>
        <el-button @click="resetQuery">
          <Icon class="mr-5px" icon="ep:refresh" />
          重置
        </el-button>
        <el-button
          v-hasPermi="['crm:bid-platform:create']"
          type="primary"
          @click="openForm('create')"
        >
          <Icon class="mr-5px" icon="ep:plus" />
          新增
        </el-button>
        <el-button
          v-hasPermi="['crm:bid-platform:import']"
          plain
          type="warning"
          @click="openImport"
        >
          <Icon class="mr-5px" icon="ep:upload" />
          导入
        </el-button>
        <el-button
          v-hasPermi="['crm:bid-platform:export']"
          :loading="exportLoading"
          plain
          type="success"
          @click="handleExport"
        >
          <Icon class="mr-5px" icon="ep:download" />
          导出
        </el-button>
      </el-form-item>
    </el-form>
  </ContentWrap>

  <!-- 列表 -->
  <ContentWrap>
    <el-table v-loading="loading" :data="list" :show-overflow-tooltip="true" :stripe="true">
      <el-table-column align="center" fixed="left" label="收费标准" prop="feeStandard" width="110">
        <template #default="scope">
          <dict-tag
            :type="DICT_TYPE.CRM_BID_PLATFORM_FEE_STANDARD"
            :value="scope.row.feeStandard"
          />
        </template>
      </el-table-column>
      <el-table-column align="center" label="类型" prop="type" width="100">
        <template #default="scope">
          <dict-tag :type="DICT_TYPE.CRM_BID_PLATFORM_TYPE" :value="scope.row.type" />
        </template>
      </el-table-column>
      <el-table-column align="center" label="平台名称" prop="name" width="220">
        <template #default="scope">
          <el-link
            v-if="scope.row.website"
            :href="scope.row.website"
            :underline="false"
            target="_blank"
            type="primary"
          >
            {{ scope.row.name }}
          </el-link>
          <span v-else>{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="网址" prop="website" width="260" />
      <el-table-column align="center" label="第三方评价" prop="thirdPartyEvaluation" width="220" />
      <el-table-column
        align="center"
        label="站长工具统计具体的平台流量分析"
        prop="trafficAnalysis"
        width="260"
      />
      <el-table-column align="center" label="账号/密码" prop="accountPassword" width="160" />
      <el-table-column align="center" label="合作状态" prop="cooperationStatus" width="110">
        <template #default="scope">
          <dict-tag
            :type="DICT_TYPE.CRM_BID_PLATFORM_COOPERATION_STATUS"
            :value="scope.row.cooperationStatus"
          />
        </template>
      </el-table-column>
      <el-table-column align="center" label="费用说明" prop="feeDesc" width="260" />
      <el-table-column align="center" label="备注" prop="remark" width="220" />
      <el-table-column
        align="center"
        fixed="right"
        :show-overflow-tooltip="false"
        label="操作"
        width="110"
      >
        <template #default="scope">
          <div class="crm-bid-platform-action">
            <el-dropdown trigger="click" @command="(command) => handleCommand(command, scope.row)">
              <el-button link type="primary">
                操作
                <Icon class="ml-2px" icon="ep:arrow-down" />
              </el-button>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item v-hasPermi="['crm:bid-platform:update']" command="edit">
                    编辑
                  </el-dropdown-item>
                  <el-dropdown-item v-hasPermi="['crm:bid-platform:delete']" command="delete">
                    删除
                  </el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <Pagination
      v-model:limit="queryParams.pageSize"
      v-model:page="queryParams.pageNo"
      :total="total"
      @pagination="getList"
    />
  </ContentWrap>

  <!-- 表单弹窗：添加/修改 -->
  <BidPlatformForm ref="formRef" @success="getList" />
  <BidPlatformImportForm ref="importFormRef" @success="getList" />
</template>

<script lang="ts" setup>
import { DICT_TYPE, getIntDictOptions } from '@/utils/dict'
import download from '@/utils/download'
import { BidPlatformApi, BidPlatformVO } from '@/api/crm/bidPlatform'
import BidPlatformForm from './BidPlatformForm.vue'
import BidPlatformImportForm from './BidPlatformImportForm.vue'

defineOptions({ name: 'CrmBidPlatform' })

const message = useMessage() // 消息弹窗
const { t } = useI18n() // 国际化

const loading = ref(true) // 列表的加载中
const total = ref(0) // 列表的总页数
const list = ref<BidPlatformVO[]>([]) // 列表的数据
const exportLoading = ref(false) // 导出的加载中

const queryParams = reactive<any>({
  pageNo: 1,
  pageSize: 10,
  keyword: undefined,
  type: undefined,
  feeStandard: undefined,
  cooperationStatus: undefined
})
const queryFormRef = ref() // 搜索的表单

/** 查询列表 */
const getList = async () => {
  loading.value = true
  try {
    const data = await BidPlatformApi.getBidPlatformPage(queryParams)
    list.value = data.list
    total.value = data.total
  } finally {
    loading.value = false
  }
}

/** 搜索按钮操作 */
const handleQuery = () => {
  queryParams.pageNo = 1
  getList()
}

/** 重置按钮操作 */
const resetQuery = () => {
  queryFormRef.value.resetFields()
  queryParams.keyword = undefined
  queryParams.type = undefined
  queryParams.feeStandard = undefined
  queryParams.cooperationStatus = undefined
  handleQuery()
}

/** 添加/修改操作 */
const formRef = ref<InstanceType<typeof BidPlatformForm>>()
const openForm = (type: string, id?: number) => {
  formRef.value?.open(type, id)
}

/** 导入操作 */
const importFormRef = ref<InstanceType<typeof BidPlatformImportForm>>()
const openImport = () => {
  importFormRef.value?.open()
}

/** 操作列命令 */
const handleCommand = async (command: string, row: BidPlatformVO) => {
  if (command === 'edit') {
    openForm('update', row.id)
    return
  }
  if (command === 'delete') {
    await handleDelete(row.id!)
  }
}

/** 删除按钮操作 */
const handleDelete = async (id: number) => {
  try {
    // 删除的二次确认
    await message.delConfirm()
    // 发起删除
    await BidPlatformApi.deleteBidPlatform(id)
    message.success(t('common.delSuccess'))
    // 刷新列表
    await getList()
  } catch {}
}

/** 导出按钮操作 */
const handleExport = async () => {
  try {
    // 导出的二次确认
    await message.exportConfirm()
    // 发起导出
    exportLoading.value = true
    const data = await BidPlatformApi.exportBidPlatform(queryParams)
    download.excel(data, '招标平台汇总.xlsx')
  } catch {
  } finally {
    exportLoading.value = false
  }
}

/** 初始化 **/
onMounted(async () => {
  await getList()
})
</script>

<style lang="scss" scoped>
/**
 * 操作列对齐：.el-dropdown 是 vertical-align: top，.el-button 是 middle，混排会偏高，
 * 这里统一交给 flex 垂直居中。
 */
.crm-bid-platform-action {
  display: flex;
  align-items: center;
  justify-content: center;

  :deep(.el-button + .el-button) {
    margin-left: 0;
  }
}
</style>
